import { AfterViewInit, Component, OnInit } from '@angular/core';
import { LoginDetails } from 'src/app/models/settings/login-details.model';
import { AuthService } from '../auth.service';
import * as _ from 'lodash';
import { FormWizardPage, FormWizardPageElement, FormWizardTemplate } from 'src/app/models/form-wizard-template.model';
import { Common } from 'src/app/common';
import { LoginResult } from 'src/app/models/settings/login-result.model';
import { Router } from '@angular/router';
import { SessionService } from 'src/app/services/session.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  private loginDetails: LoginDetails = new LoginDetails();

  public loginFormWizard?: FormWizardTemplate;
  public formValues: any = {};
  public loginFailed = false;
  public errorMessage = '';

  constructor(
    private authService: AuthService,
    private sessionService: SessionService,
    private router: Router) { }

  ngOnInit(): void {
    setTimeout(() => this.loadLoginDetails(), 0);
  }

  private loadLoginDetails(): void {
    this.sessionService.showLoading();

    this.authService.getLoginDetails().subscribe({
      next: (result) => this.loadLoginDetailsOk(result),
      error: (error) => this.loadLoginDetailsError(error.error)
    });
  }

  private loadLoginDetailsOk(result: LoginDetails) {
    this.loginDetails = result;
    this.setLoginFormWizard();

    this.sessionService.hideLoading();
  }

  private loadLoginDetailsError(error: any) {
    this.sessionService.hideLoading();

    this.sessionService.showErrorDialog('Error loading login details. Please refresh the page to try again.');
  }

  private processLogin(): void {
    this.sessionService.showProcessing();
    this.loginFailed = false;

    this.authService.validateLogin(this.loginDetails.userToken, this.getRefIdValue(), this.getOtherValues()).subscribe({
      next: (result) => this.processLoginOk(result),
      error: (error) => this.processLoginError(error.error)
    });
  }

  private processLoginOk(result: LoginResult) {
    if (result.success) {
      this.sessionService.setSessionDetailsFromLoginResult(result);

      this.router.navigate(['/']);
    } else {
      // TODO: put non success handling here? does it use the generic error message?
    }

    this.sessionService.hideProcessing();
  }

  private processLoginError(error: any) {
    this.errorMessage = error.message;
    this.loginFailed = true;

    this.sessionService.hideProcessing();
  }

  public isWizardVisible(): boolean {
    return !_.isNil(this.loginFormWizard);
  }

  public formWizardActionHandler(action: string): void {
    switch (action) {
      case 'complete':
        this.handleFormSubmit();
        break;
    }
  }

  private handleFormSubmit(): void {
    this.processLogin();
  }

  private getRefIdValue(): string {
    return this.formValues.refId ?? '';
  }

  private getOtherValues(): any {
    const values = _.cloneDeep(this.formValues);
    delete values.refId;
    
    return values;
  }

  private setLoginFormWizard(): void {
    const referenceIdField = _.find(this.loginDetails.valFlds, (field) => field.fldName === 'refId');
    const otherFields = _.filter(this.loginDetails.valFlds, (field) => field.fldName !== 'refId');
    const loginWizard = new FormWizardTemplate();
    const loginPage = new FormWizardPage();
    loginWizard.pages.push(loginPage);

    loginWizard.rightSectionHtml = '<div></div>';
    loginPage.previousButtonLabel = '';
    loginPage.nextButtonLabel = '';
    loginPage.completeButtonLabel = 'Login';
    loginPage.completeButtonClasses = 'button-primary w-100';
    loginPage.label = this.loginDetails.lblLoginTitle;

    loginPage.elements.push({
      type: 'heading',
      name: '',
      label: this.loginDetails.lblLoginTitle,
      class: 'col-12',
      required: false,
    } as FormWizardPageElement);

    if (!_.isNil(referenceIdField)) {
      loginPage.elements.push(Common.convertValueFieldToWizardElement(referenceIdField));
    }

    if (otherFields.length > 0) {
      loginPage.elements.push({
          type: 'paragraph',
          name: '',
          label: this.loginDetails.lblHelpText,
          class: 'col-12',
          required: false,
      } as FormWizardPageElement);

      otherFields.forEach((field) => {
        loginPage.elements.push(Common.convertValueFieldToWizardElement(field));
      });
    }

    this.loginFormWizard = loginWizard;
  }
}
